import { API_URL } from './config';
import { Sponsor } from '../../types/Sponsor';

export const sponsorsService = {
    create: async (data: Partial<Sponsor>): Promise<Sponsor> => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/manager/sponsors`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to create sponsor");
        return res.json();
    },

    listByClub: async (clubId: string): Promise<Sponsor[]> => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/clubs/${clubId}/sponsors`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) throw new Error("Failed to list sponsors");
        return res.json();
    },

    delete: async (id: string): Promise<boolean> => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/manager/sponsors/${id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return res.ok;
    },

    update: async (id: string, data: Partial<Sponsor>): Promise<boolean> => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/manager/sponsors/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return res.ok;
    },

    uploadLogo: async (file: Blob): Promise<{ url: string }> => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/manager/sponsors/upload`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'image/jpeg'
            },
            body: file
        });
        if (!res.ok) throw new Error("Logo upload failed");
        return res.json();
    }
};
